import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { ZipUtils, JSZip } from '@/utils/zipUtils';
import { FileUtils } from '@/utils/fileUtils';
import { DriveItem } from '@/models/driveItem';
import Loading from '@/components/Loading.vue';
import { DriveItems } from '@/models/driveItems';

@Component({
	components: {
		Loading
	}
})
export default class DownloadZipButton extends Vue {
	@Prop() public title!: string;
	@Prop() public driveItems!: DriveItem[];
	@Prop() public zipFileName!: string;
	@Prop() public disabled!: boolean;
	private downloading: boolean = false;
	// lifecycle event
	public created(): void {
	}

	@Emit("downloadZipButton-click")
	public click() { }
	@Emit("download-started")
	public onDownloadStarted() {
		this.downloading = true;
	}
	@Emit("download-ended")
	public onDownloadEnded() {
		this.downloading = false;
	}

	@Watch('driveItems')
	private onDriveItemsChange(newItems: DriveItem[], oldItems: DriveItem[]): void { }

	private async onClick(): Promise<void> {
		if (this.disabled || this.downloading || (this.driveItems === undefined)) {
			return;
		}
		this.onDownloadStarted();
		let fileCount: number = 0;
		ZipUtils.init();
		this.driveItems.forEach((driveItem) => {
			const request: XMLHttpRequest = new XMLHttpRequest();
			request.onload = () => {
				const data = request.response;
				ZipUtils.addFile(driveItem.name, data);
				fileCount++;
				if (fileCount === this.driveItems.length) {
					this.generateZip(`${this.zipFileName}.zip`);
				}
			};
			request.open("GET", driveItem.downloadUrl);
			request.responseType = 'blob';
			request.send();
		});
	}

	private async generateZip(fileName: string): Promise<void> {
		const zipPromise: Promise<Blob> = ZipUtils.generateZipBlob();
		zipPromise.then(
			(zipBlob: Blob) => {
				FileUtils.SaveFile(zipBlob, fileName);
				this.onDownloadEnded();
			}, (failReason) => {
				console.error(failReason);
				this.onDownloadEnded();
			}
		);
	}
}
